const currentYear = new Date().getFullYear();
const numberOfYears = 5;
const years = [];

for (let i = 0; i < numberOfYears; i++) {
    years.push(currentYear + i);
}

export default years;
